import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from '../../forum/app';
import Component from '../../common/Component';
import Link from '../../common/components/Link';
import highlight from '../../common/helpers/highlight';
import ItemList from '../../common/utils/ItemList';
export default class DiscussionsSearchItem extends Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "query", void 0);
    _defineProperty(this, "discussion", void 0);
    _defineProperty(this, "mostRelevantPost", void 0);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.query = this.attrs.query;
    this.discussion = this.attrs.discussion;
    this.mostRelevantPost = this.attrs.mostRelevantPost;
  }
  view() {
    return m("li", {
      className: "DiscussionSearchResult",
      "data-index": 'discussions' + this.discussion.id()
    }, m(Link, {
      href: app.route.discussion(this.discussion, this.mostRelevantPost && this.mostRelevantPost.number() || 0)
    }, this.viewItems().toArray()));
  }
  discussionTitle() {
    return this.discussion.title();
  }
  mostRelevantPostContent() {
    return this.mostRelevantPost?.contentPlain();
  }
  viewItems() {
    const items = new ItemList();
    items.add('discussion-title', m("div", {
      className: "DiscussionSearchResult-title"
    }, highlight(this.discussionTitle(), this.query)), 90);
    !!this.mostRelevantPost && items.add('most-relevant', m("div", {
      className: "DiscussionSearchResult-excerpt"
    }, highlight(this.mostRelevantPostContent() ?? '', this.query, 100)), 80);
    return items;
  }
}
flarum.reg.add('core', 'forum/components/DiscussionsSearchItem', DiscussionsSearchItem);